export const ZENDESK_URLS = {
    HELPCENTER: "HELPCENTER",
    BATTERY_REPLACEMENT: "BATTERY_REPLACEMENT",
    FAN_COIL_SETUP: "FAN_COIL_SETUP",
    RETOURE_MANUAL: "RETOURE_MANUAL",
    USER_ROLES: "USER_ROLES",
    ACTILITY_INTEGRATION: "ACTILITY_INTEGRATION",
    ACTILITY_INTEGRATION_CLOUD: "ACTILITY_INTEGRATION_CLOUD",
    LNS_ACTILITY_INTEGRATION: "LNS_ACTILITY_INTEGRATION",
    LNS_TTI_INTEGRATION: "LNS_TTI_INTEGRATION",
    PMS_IBELSA_INTEGRATION: "PMS_IBELSA_INTEGRATION",
    MONITOR: "MONITOR",
    DEVICE_DETAILS: "DEVICE_DETAILS",
    DEVICE_ADVANCED_SETTINGS: "DEVICE_ADVANCED_SETTINGS",
    DEVICE_TEMPERATURE_OFFSET: "DEVICE_TEMPERATURE_OFFSET",
    DEVICE_MAX_VALVE_OPENING: "DEVICE_MAX_VALVE_OPENING",
    DEVICE_VALVE_EMERGENCY_POSITION: "DEVICE_VALVE_EMERGENCY_POSITION",
    DEVICE_ADAPTIVE_TEMPERATURE_CONTROL: "DEVICE_ADAPTIVE_TEMPERATURE_CONTROL",
    MCLIMATE_VICKI_INSTALLATION: "MCLIMATE_VICKI_INSTALLATION",
    HEATING_PREFERENCE: "HEATING_PREFERENCE",
};

export const ZENDESK_URL_MAPPING = {
    de: {
        [ZENDESK_URLS.HELPCENTER]: "https://betterspace.zendesk.com/hc/de",
        [ZENDESK_URLS.BATTERY_REPLACEMENT]:
            "https://betterspace.zendesk.com/hc/de/articles/13342013394077-Batterien-wechseln",
        [ZENDESK_URLS.FAN_COIL_SETUP]:
            "https://betterspace.zendesk.com/hc/de/sections/16153530010781-Fan-Coil-Thermostat-MClimate",
        [ZENDESK_URLS.RETOURE_MANUAL]:
            "https://betterspace.zendesk.com/hc/de/articles/10921861994013-Retouren-Anleitung",
        [ZENDESK_URLS.USER_ROLES]:
            "https://betterspace.zendesk.com/hc/de/articles/11798032988445-%C3%9Cbersicht-der-Benutzer-Rollen",
        [ZENDESK_URLS.ACTILITY_INTEGRATION]:
            "https://betterspace.zendesk.com/hc/de/articles/17313395198621-Actility-Integration",
        [ZENDESK_URLS.ACTILITY_INTEGRATION_CLOUD]:
            "https://betterspace.zendesk.com/hc/de/articles/19311563810973-Actility-Thing-Park-X-Cloud-Aufsetzen-Bearbeiten-L%C3%B6schen#01HZHGDV1EAJFCA059C1BPV0K9",
        [ZENDESK_URLS.LNS_ACTILITY_INTEGRATION]:
            "https://betterspace.zendesk.com/hc/de/articles/17313395198621-Actility-Thing-Park-X-Aufsetzten-Bearbeiten-L%C3%B6schen",
        [ZENDESK_URLS.LNS_TTI_INTEGRATION]:
            "https://betterspace.zendesk.com/hc/de/articles/18611470813597-The-Things-Industires-TTI-Aufsetzten-Bearbeiten-L%C3%B6schen",
        [ZENDESK_URLS.MONITOR]:
            "https://betterspace.zendesk.com/hc/de/articles/18929030032669-Modul-W%C3%A4rmemengen-Erfassung",
        [ZENDESK_URLS.DEVICE_DETAILS]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen",
        [ZENDESK_URLS.DEVICE_ADVANCED_SETTINGS]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Erweiterten%20Einstellungen",
        [ZENDESK_URLS.DEVICE_TEMPERATURE_OFFSET]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Erweiterten%20Einstellungen",
        [ZENDESK_URLS.DEVICE_MAX_VALVE_OPENING]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Maximale%20Ventilstellung",
        [ZENDESK_URLS.DEVICE_VALVE_EMERGENCY_POSITION]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Erweiterten%20Einstellungen",
        [ZENDESK_URLS.DEVICE_ADAPTIVE_TEMPERATURE_CONTROL]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Erweiterten%20Einstellungen",
        [ZENDESK_URLS.MCLIMATE_VICKI_INSTALLATION]:
            "https://betterspace.zendesk.com/hc/de/articles/8756958282909-MClimate-Vicki-Installation",
        [ZENDESK_URLS.HEATING_PREFERENCE]:
            "https://betterspace.zendesk.com/hc/de/articles/34577600010269-Heizverhalten-des-Systems-Energiesparen-Komfort",
    },
    en: {
        [ZENDESK_URLS.HELPCENTER]: "https://betterspace.zendesk.com/hc/de", // no en translation available
        [ZENDESK_URLS.BATTERY_REPLACEMENT]:
            "https://betterspace.zendesk.com/hc/de/articles/13342013394077-Batterien-wechseln", // no en translation available
        [ZENDESK_URLS.FAN_COIL_SETUP]:
            "https://betterspace.zendesk.com/hc/de/sections/16153530010781-Fan-Coil-Thermostat-MClimate", // no en translation available
        [ZENDESK_URLS.RETOURE_MANUAL]:
            "https://betterspace.zendesk.com/hc/de/articles/10921861994013-Retouren-Anleitung", // no en translation available
        [ZENDESK_URLS.USER_ROLES]:
            "https://betterspace.zendesk.com/hc/de/articles/11798032988445-%C3%9Cbersicht-der-Benutzer-Rollen", // no en translation available
        [ZENDESK_URLS.ACTILITY_INTEGRATION]:
            "https://betterspace.zendesk.com/hc/en-150/articles/17313395198621-Actility-Integration",
        [ZENDESK_URLS.ACTILITY_INTEGRATION_CLOUD]:
            "https://betterspace.zendesk.com/hc/de/articles/19311563810973-Actility-Thing-Park-X-Cloud-Aufsetzen-Bearbeiten-L%C3%B6schen#01HZHGDV1EAJFCA059C1BPV0K9", // no en translation available
        [ZENDESK_URLS.LNS_ACTILITY_INTEGRATION]:
            "https://betterspace.zendesk.com/hc/de/articles/17313395198621-Actility-Thing-Park-X-Aufsetzten-Bearbeiten-L%C3%B6schen", // no en translation available
        [ZENDESK_URLS.LNS_TTI_INTEGRATION]:
            "https://betterspace.zendesk.com/hc/de/articles/18611470813597-The-Things-Industires-TTI-Aufsetzten-Bearbeiten-L%C3%B6schen", // no en translation available
        [ZENDESK_URLS.MONITOR]:
            "https://betterspace.zendesk.com/hc/de/articles/18929030032669-Modul-W%C3%A4rmemengen-Erfassung",
        [ZENDESK_URLS.DEVICE_DETAILS]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen", // no en translation available
        [ZENDESK_URLS.DEVICE_ADVANCED_SETTINGS]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Erweiterten%20Einstellungen", // no en translation available
        [ZENDESK_URLS.DEVICE_TEMPERATURE_OFFSET]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Erweiterten%20Einstellungen", //no en translation available
        [ZENDESK_URLS.DEVICE_MAX_VALVE_OPENING]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Maximale%20Ventilstellung", //no en translation available
        [ZENDESK_URLS.DEVICE_VALVE_EMERGENCY_POSITION]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Erweiterten%20Einstellungen", //no en translation available
        [ZENDESK_URLS.DEVICE_ADAPTIVE_TEMPERATURE_CONTROL]:
            "https://betterspace.zendesk.com/hc/de/articles/16391758141341-Ger%C3%A4tedetails-einsehen#:~:text=Erweiterten%20Einstellungen", //no en translation available
        [ZENDESK_URLS.MCLIMATE_VICKI_INSTALLATION]:
            "https://betterspace.zendesk.com/hc/de/articles/8756958282909-MClimate-Vicki-Installation", //no en translation available
        [ZENDESK_URLS.HEATING_PREFERENCE]:
            "https://betterspace.zendesk.com/hc/de/articles/34577600010269-Heizverhalten-des-Systems-Energiesparen-Komfort", //no en translation available
    },
};
